module.exports = "https://assets.sidelineswap.com/web/_next/static/images/ios-app-store-e2ad74248e76b38de2d89aef08fe8f2f.png";